/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: CustomerProfileContract
 */

import { customerprofileApi } from '../api/customerprofile.api';
import { createSimpleQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { GetUserMerchantsResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useGetUserMerchants = createSimpleQueryHook<GetUserMerchantsResponseType['data']>(
  () => customerprofileApi.getUserMerchants(),
  queryKeys.customerprofile.getUserMerchants()
);